import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { DialogRef } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-ref';
import { DIALOG_DATA } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-tokens';
import { DialogSize } from '@gelato-api-ui/sdk/src/lib/shared/dialog/types/dialog-size';

interface ProductTemplateNameModalContext {
  templateName: string;
  title: string;
  previewUrl?: string;
  description: string;
  actionButtonText: string;
  allowInitialTemplateName: boolean;
}

@Component({
  selector: 'gd-product-template-name-modal',
  templateUrl: './product-template-name-modal.component.html',
  styleUrls: ['./product-template-name-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplateNameModalComponent implements OnInit {
  initialTemplateName: string;
  templateName: string;
  allowInitialTemplateName: boolean;
  previewUrl?: string;

  size = DialogSize.Small;

  constructor(
    private readonly dialogRef: DialogRef,
    @Inject(DIALOG_DATA) private readonly dialogData: ProductTemplateNameModalContext,
  ) {}

  ngOnInit() {
    const { templateName, allowInitialTemplateName, previewUrl } = this.dialogData;

    this.initialTemplateName = templateName;
    this.templateName = templateName;
    this.allowInitialTemplateName = allowInitialTemplateName;
    this.previewUrl = previewUrl;
  }

  close() {
    this.dialogRef.close(undefined);
  }

  approve() {
    this.dialogRef.close(this.templateName);
  }

  get context() {
    return this.dialogData;
  }

  get approveDisabled() {
    return !this.templateName || (!this.allowInitialTemplateName && this.templateName === this.initialTemplateName);
  }
}
